import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { IoService } from '../../../services/io/io.service';
import { SupportService } from '../../../services/support/support.service';
import { SettingsService } from '../../../services/settings/settings.service';
import { LoadingComponent } from '../../shared/loading/loading.component';
import { AppComponent } from '../../../app.component';

@Component({
  selector: 'app-editor-list',
  templateUrl: './editor-list.component.html',
  styleUrls: ['./editor-list.component.scss']
})
export class EditorListComponent implements OnInit {

  editorType: string;
  documents = [];
  showInactive = false;
  loaded = false;

  supportActive = false;
  settingsActive = false;

  constructor(
    private ioService: IoService,
    private supportService: SupportService,
    private settingsService: SettingsService,
    private route: ActivatedRoute,
    private router: Router
  ) { }

  ngOnInit(): void {
    this.route.data.subscribe(data => {
      this.editorType = data.editorType;
      this.loadDocuments();
    });

    this.supportService.supportActive$.subscribe((active) => {
      this.supportActive = active;
    });
    this.supportActive = this.supportService.isSupportActive();

    this.settingsService.settingsActive$.subscribe((active) => {
      this.settingsActive = active;
    });
    this.settingsActive = this.settingsService.isSettingsActive();
  }

  get title() {
    return this.editorType === 'report' ? 'Report Editor' : 'View Editor';
  }

  get visibleDocuments() {
    if (this.showInactive) {
      return this.documents;
    }
    return this.documents.filter(document => document.active !== false);
  }

  loadDocuments() {
    this.loaded = false;
    LoadingComponent.showLoading();

    const path = this.editorType === 'report' ? '/reportEditor/getReports' : '/viewEditor/getViews';

    this.ioService.post(path, {}).then((documents: any) => {
      this.documents = documents;
      this.loaded = true;
      LoadingComponent.hideLoading();
    }).catch((err: any) => {
      LoadingComponent.hideLoading();
      AppComponent.showSnack(err.error && err.error.msg ? err.error.msg : 'Unable to load documents.', 'OK', 5000);
    });
  }

  toggleShowInactive(checked: boolean) {
    this.showInactive = checked;
  }

  openDocument(document) {
    this.router.navigate(['/editor', this.editorType === 'report' ? 'reports' : 'views', document._id]);
  }

  newDocument() {
    this.router.navigate(['/editor', this.editorType === 'report' ? 'reports' : 'views', 'new']);
  }
}
